module.exports = __webpack_public_path__ + "img/inspiration-4@2x.97da092.jpg";